<template>
  <section>
    <div class="container wfs--main">
      <div class="row">
        <div class="col-md-12 bread">
          <ol class="bread-crumb breadcrumb-fill0">
            <li>
              <router-link to="/home">home</router-link>
            </li>
            <li>
              <a href="javascript:void(0);" class="bread-text">manifesto</a>
            </li>
          </ol>
        </div>

        <div
          class="col-md-12"
          v-if="msgAlterada"
          style="padding-left: 0px; padding-right: 0px"
        >
          <div
            class="card"
            style="
              background-color: rgb(50 170 159) !important;
              color: #fff !important;
              margin-bottom: 20px !important;
            "
            v-if="msg == 1"
          >
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">{{ msgAlterada }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12" style="margin-bottom: 20px" v-if="formulario != 1">
          <h3>Como Deseja se Manifestar?</h3>
          <button
            type="submit"
            class="btn btn-default btn-fill float-left"
            @click.prevent="anonimo"
            style="margin-right: 5px"
          >
            Anônimo
          </button>
          <button
            type="submit"
            class="btn btn-primary btn-fill float-left"
            @click.prevent="ativarFormularioLogin"
          >
            Logar
          </button>
        </div>

        <div
          class="col-md-12"
          v-if="msgAlterada"
          style="padding-left: 0px; padding-right: 0px"
        >
          <div
            class="card"
            style="
              background-color: rgb(170 72 50) !important;
              color: #fff !important;
              margin-bottom: 20px !important;
            "
            v-if="msg == 0"
          >
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">{{ msgAlterada }}</div>
              </div>
            </div>
          </div>
          <div
            class="card"
            style="
              background-color: rgb(191 187 54) !important;
              color: #fff !important;
              margin-bottom: 20px !important;
            "
            v-if="msg == 2"
          >
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">{{ msgAlterada }}</div>
              </div>
            </div>
          </div>
        </div>
        <reload  v-if="reload_hab"></reload>
        <card class="col-md-12" v-if="formulario == 1">
          <h4 slot="header" class="card-title">Manifestação</h4>
          <form>
            {{this.opcaoTipo()}}
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="sel1">Tipo:</label>
                  <select
                    class="form-control"
                    id="tipo"
                    name="tipo"
                    v-model="manifesto.tipo"
                  >
                    <option v-for="a in tiposAssunto" :key="a.id" :value="a.nome">
                      {{ a.nome }}
                    </option>
                  </select>
                </div>
              </div>
              
              <!--<div class="col-md-6">
                <div class="form-group">
                  <label for="sel1">Para onde deseja enviar sua manifestação?</label>
                  <select
                    class="form-control"
                    id="secretaria"
                    name="secretaria"
                    v-model="manifesto.secretaria"
                  >
                    <option :value="1">Nenhuma</option>
                    <option v-for="a in secretarias" :key="a.id" :value="a.id">
                      {{ a.secretaria }}
                    </option>
                  </select>
                </div>
              </div>-->
            </div>
            
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label >Assunto:</label><br>
                  <label for="sel1" class="manif-tipo-color">Sobre qual assunto você quer falar?</label>
                  <input
                    type="text"
                    placeholder="Assunto"
                    maxlength="250"
                    v-model="manifesto.assunto"
                    v-on:blur="validacaoAssunto(manifesto.assunto)"
                    class="form-control"
                    :style="styleAssunto"
                  />
                  <div v-if="assuntoverify == 0">
                    <label
                      class="control-label"
                      v-if="styleAssunto != ''"
                      style="color: rgb(243 0 0); font-size: 12px"
                      >*Obrigatorio</label
                    >
                  </div>
                  <label
                    class="control-label"
                    v-if="assuntoverify == 1"
                    style="color: rgb(183 179 55); font-size: 12px"
                    >* Minimo 6 caracteres</label
                  >
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="descricao">Descrição:</label><br>
                  <label class="manif-tipo-color"> 
                    Descreva abaixo o que deseja.
                    Seja claro e objetivo. Não utilize o campos abaixo para
                    informações pessoais, só informe dados que são essenciais
                    para a caracterização da manifestação.
                  </label>
                  <textarea
                    class="form-control"
                    rows="5"
                    id="descricao"
                    name="descricao"
                    v-model="manifesto.descricao"
                    v-on:blur="validacaoDescricao(manifesto.descricao)"
                    :style="styleDescricao"
                    maxlength="1000"
                  ></textarea>
                  <div v-if="descricaoverify == 0">
                    <label
                      class="control-label"
                      v-if="styleDescricao != ''"
                      style="color: rgb(243 0 0); font-size: 12px"
                      >*Obrigatorio</label
                    >
                  </div>
                  <label class="control-label" v-if="manifesto.descricao != null">{{
                    manifesto.descricao.length
                  }}</label
                  ><br />
                  <label
                    class="control-label"
                    v-if="descricaoverify == 1"
                    style="color: rgb(183 179 55); font-size: 12px"
                    >* Minimo 30 caracteres</label
                  >
                </div>
              </div>
            </div>
            <div class="row" v-if="manifesto.tipo != 'Elogio'">
              <div class="col-md-12">
                <h4>Local da Ocorrência</h4>
              </div>
            </div>
            <div class="row" v-if="manifesto.tipo != 'Elogio'">
              <div class="col-md-10">
                <base-input
                  type="text"
                  id="rua"
                  name="rua"
                  label="Rua"
                  placeholder="Rua"
                  v-model="manifesto.rua"
                  maxlength="150"
                ></base-input>
              </div>
              <div class="col-md-2">
                <base-input
                  type="number"
                  id="numero"
                  name="numero"
                  label="Número"
                  placeholder="Número"
                  v-model="manifesto.numero"
                  maxlength="150"
                ></base-input>
              </div>
            </div>
            <div class="row" v-if="manifesto.tipo != 'Elogio'">
              <div class="col-md-7">
                <base-input
                  type="text"
                  id="complemento"
                  name="complemento"
                  label="Complemento"
                  placeholder="Complemento"
                  v-model="manifesto.complemento"
                  maxlength="150"
                ></base-input>
              </div>
              <div class="col-md-5">
                <base-input
                  type="text"
                  id="bairro"
                  name="bairro"
                  label="Bairro"
                  placeholder="Bairro"
                  v-model="manifesto.bairro"
                  maxlength="150"
                ></base-input>
              </div>
            </div>
            <div class="text-center">
              <button
                type="submit"
                class="btn btn-primary btn-fill float-left"
                @click.prevent="manifestoCadastrar"
              >
                Cadastrar Manifestação
              </button>
              <button
                type="submit"
                class="btn btn-danger btn-fill float-left"
                style="margin-left: 5px"
                @click.prevent="cancelar"
              >
                Cancelar
              </button>
            </div>
            <div class="clearfix" style="margin-bottom: 20px"></div>
          </form>
        </card>
      </div>
    </div>
  </section>  
</template>
<script>
import Reload from 'src/components/Reload-v1.vue'
import Card from "src/components/Cards/Card.vue";
import axios from "axios";
import store from "src/store.js";
import "src/controller/site/manifestacaoController.js";
import "src/controller/site/homeController.js";
import "src/controller/tiposController.js";

export default {
  name: "Manifestação",
  metaInfo: {
    htmlAttrs: {
      lang: "pt-BR",
    },
    title: "Manifestar-se",
    meta: [
      {
        name: "descrition",
        content:
          "Realizar uma Manifestação na Ouvidoria da Prefeitura Municipal de São José de Ubá.",
      },
      { property: "og:title", content: "Manifestar-se" },
      { property: "og:image", content: "/img/logo-topo.png" },
    ],
  },
  props: {
    opcao: {
      require:false,
    },
  },
  components: {
    Card,
    Reload
  },
  data() {
    return {
      reload_hab:false,
      formulario: null,
      manifesto: {
        tipo: "",
        secretaria: 1,
        assunto: null,
        descricao: "",
        rua: null,
        numero: null,
        bairro: null,
        complemento: null,
      },
      secretarias: [],
      tiposAssunto: [],
      msgAlterada: null,
      msg: null,
      assuntoverify: 0,
      descricaoverify: 0,
      styleAssunto: "",
      styleDescricao: "",
      verify_assunto: false,
      verify_descricao: false,
    };
  },
  methods: {
    anonimo() {
      this.formulario = 1;
      this.msgAlterada = "";
      this.styleAssunto = "";
      this.styleDescricao = "";
      this.manifesto.tipo = "Reclamação";
      this.manifesto.secretaria = 1;
      this.manifesto.assunto = null;
      this.manifesto.descricao = null;
      this.manifesto.rua = null;
      this.manifesto.numero = null;
      this.manifesto.bairro = null;
      this.manifesto.complemento = null;
    },
    ativarFormularioLogin() {
      this.$router.push({ name: "loginCidadao" });
    },
    cancelar() {
      this.msgAlterada = "";
      this.styleAssunto = "";
      this.styleDescricao = "";
      this.formulario = null;
    },
    validacaoAssunto(assunto) {
      if (assunto) {
        this.msgAlterada = "";
        this.styleAssunto = "";
        this.styleDescricao = "";

        if (assunto.length <= 5) {
          this.msgAlterada =
            "O campo Assunto deve possuir no minimo 6 Caracteres!";
          this.msg = 2;
          this.assuntoverify = 1;
          this.verify_assunto = false;
          return false;
        } else {
          this.msgAlterada = "";
        }

        this.assuntoverify = 0;
        this.verify_assunto = true;
      } else {
        this.styleAssunto = "border: 2px solid rgb(243 0 0);";
        this.msgAlterada = "O campo Assunto está Vazio!";
        this.msg = 0;
        this.assuntoverify = 0;
        this.verify_assunto = false;
        return false;
      }
    },
    validacaoDescricao(descricao) {
      if (descricao) {
        this.msgAlterada = "";
        this.styleAssunto = "";
        this.styleDescricao = "";

        if (descricao.length <= 30) {
          this.msgAlterada =
            "O campo Descrição deve possuir no minimo 30 Caracteres!";
          this.msg = 2;
          this.descricaoverify = 1;
          this.verify_descricao = false;
          return false;
        } else {
          this.msgAlterada = "";
        }

        this.descricaoverify = 0;
        this.verify_descricao = true;
      } else {
        this.styleDescricao = "border: 2px solid rgb(243 0 0);";
        this.msgAlterada = "O campo Descrição está Vazio!";
        this.msg = 0;
        this.descricaoverify = 0;
        this.verify_descricao = false;
        return false;
      }
    },
    async manifestoCadastrar() {
      try {
        this.msgAlterada = "";
        this.styleAssunto = "";
        this.styleDescricao = "";

        if (this.manifesto.assunto == null || this.manifesto.assunto == "") {
          this.styleAssunto = "border: 2px solid rgb(243 0 0);";
          this.msgAlterada = "O campo Assunto está Vazio!";
          this.msg = 0;
          return false;
        }

        if (
          this.manifesto.descricao == null ||
          this.manifesto.descricao == ""
        ) {
          this.styleDescricao = "border: 2px solid rgb(243 0 0);";
          this.msgAlterada = "O campo Descricao está Vazio!";
          this.msg = 0;
          return false;
        }

        if (this.verify_descricao && this.verify_assunto) {

          scroll(0, 50);
          this.reload_hab = true;
          let data = await this.$manifestarAnonimo(this.manifesto);
          let dados = data.data;
          this.reload_hab = false;

          if (data.msg == "Campos Vazios!") {
            this.msgAlterada = data.msg;
            this.msg = 0;
            return false;
          }
          if (data.msg == "Manifestação cadastrada com sucesso!") {
            this.msgAlterada = data.msg;
            this.msg = 1;
            this.manifesto.tipo = "Elogio";
            this.manifesto.secretaria = 1;
            this.manifesto.assunto = null;
            this.manifesto.descricao = null;
            this.manifesto.rua = null;
            this.manifesto.numero = null;
            this.manifesto.bairro = null;
            this.manifesto.complemento = null;
            this.formulario = null;
          }
        }
      } catch (e) {
        //console.log(e);
        alert("Ocorreu um Error inesperado,tente Novamente!");
        this.$router.push({ name: "home" });
      }
    },
    cidadaoNovoCadastro() {
      this.$router.push({ name: "registroCidadao" });
    },
    /*async buscarSecretaria() {
      let data = await this.$secretaria();
      this.secretarias = data.data;
    },*/

    async listarTAssunto(){
      try {
        let data = await this.$listarTiposAssunto();
        this.tiposAssunto = data.data;
      } catch (e) {
        
      }
    },
    opcaoTipo(){
      if(this.opcao != null){
        //console.log(this.opcao);
        if(this.opcao == 1){
          this.manifesto.tipo = "Reclamação";
        }else if(this.opcao == 2){
          this.manifesto.tipo = "Denúncia";
        }else if(this.opcao == 3){
          this.manifesto.tipo = "Elogio";
        }else if(this.opcao == 4){
          this.manifesto.tipo = "Solicitação";
        }else if(this.opcao == 5){
          this.manifesto.tipo = "Sugestão";
        }else if(this.opcao == 6){
          this.manifesto.tipo = "Pergunta";
        }
      }
    }
  },
  beforeMount() {
    try {
      this.listarTAssunto();
      
    } catch (e) {}
  },
};
</script>
<style>
ol {
  list-style: none;
}
.bread {
  padding-right: 0px;
  padding-left: 0px;
}
.bread-crumb {
  width: 100%;
  float: left;
  margin: 0px 0px 20px 0;
  position: relative;
  display: block;
  margin-top: 8px;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
}
.breadcrumb-fill0 {
  padding: 10px;
  background: #ffffff;
  border-radius: 5px;
  box-shadow: 0 0 40px -10px rgba(0, 0, 0, 0.25);
}
.bread-crumb li {
  height: auto;
  line-height: 30px;
  float: left;
  padding: 0 12px;
}
.bread-text,
.bread-text:hover {
  color: black;
}
</style>
